import { marked } from "marked";
import { decode } from "html-entities";

export const transformString = (str) => {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

export const getFormattedAnswer = (answer) => {
  if (!answer) return "";
  return decode(answer);
};
export const getFormattedmessage = (answer) => {
  if (!answer || typeof answer !== "string") return "";

  // ✅ Remove all HTML tags
  let strippedText = answer.replace(/<\/?[^>]+>/g, "");

  // ✅ Decode HTML entities
  strippedText = decode(strippedText);

  // ✅ Remove Markdown-style bold (`**`)
  strippedText = strippedText.replace(/\*\*/g, "");

  return strippedText.trim();
};

export const formatAnswer = (answer) => {
  return marked.parse(getFormattedAnswer(answer || ""));
};
